(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["fw-font-nav"] && !window.DesignMode) return;
  try {
    
  Array.from(document.querySelectorAll(".sp-tab")).forEach(theTab => {
      theTab.onclick = () => {
          localStorage.setItem("currentTab", theTab.getAttribute("id"));
          Array.from(document.querySelectorAll(".sp-tab")).forEach(aTab => {
              if (aTab.getAttribute("id") === theTab.getAttribute("id")) {
                  aTab.classList.add("selected");
              } else {
                  aTab.classList.remove("selected");
              }
          });
          Array.from(document.querySelectorAll(".sp-tab-page")).forEach(tabPage => {
              if (tabPage.getAttribute("id").startsWith(theTab.getAttribute("id"))) {
                  tabPage.classList.add("visible");
              } else {
                  tabPage.classList.remove("visible");
              }
          });

          var slider = document.querySelector('.product-slideshow');
          if (slider) {
            var flkty = Flickity.data(slider);
            flkty.resize();
          }
        
      }
  });

  } catch(e) { console.error(e); }
})();

})();
